import { combineReducers } from 'redux';
import { ActionType } from 'typesafe-actions';

import { channelsActions } from './actions';
import {
  CHANNELS_FAILURE,
  CHANNELS_REQUEST,
  CHANNELS_SUCCESS,
} from '../../constants/channels';
import { Channel } from '../../components/TipPublish/interfaces/tip/Tip';

export type ChannelsState = {
  requested: boolean;
  data: Channel[];
  isLoading: boolean;
  error: string | null;
};
export type ChannelsActions = ActionType<typeof channelsActions>;

export const channelsReducer = combineReducers<ChannelsState, ChannelsActions>({
  requested: (state = false, action) => {
    switch (action.type) {
      case CHANNELS_REQUEST:
        return true;
      default:
        return state;
    }
  },
  data: (state = [], action) => {
    switch (action.type) {
      case CHANNELS_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  isLoading: (state = false, action) => {
    switch (action.type) {
      case CHANNELS_REQUEST:
        return true;
      default:
        return false;
    }
  },
  error: (state = null, action) => {
    switch (action.type) {
      case CHANNELS_FAILURE:
        return action.payload.message || action.payload.detail;
      default:
        return null;
    }
  },
});
